import MicroPlugin from "../../../vendor/assets/javascripts/selectize/microplugin";
globalThis.MicroPlugin = MicroPlugin;
